import { isEqual } from 'lodash/fp';

import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import { Transaction } from 'dashboard/models/transaction';
import {
  TransactionsActions,
  TransactionsActionType,
  TransactionsFilterParams,
} from 'dashboard/redux/actions/transactions';

export interface TransactionsState extends TableState<TransactionsFilterParams> {
  transactions: Record<string, Transaction[]>;
}

export const initialState: TransactionsState = {
  transactions: {},
  paginationParams: undefined,
  filters: {
    createdAtStart: undefined,
    createdAtEnd: undefined,
    tagIds: undefined,
    omni: undefined,
  },
  sortParams: {
    sort: 'updated_at',
    shouldSortDescending: true,
  },
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
};

export default (
  state: TransactionsState = initialState,
  action: TransactionsActions,
): TransactionsState => {
  switch (action.type) {
    case TransactionsActionType.SetTransactions: {
      return {
        ...state,
        transactions: {
          ...state.transactions,
          [action.payload.environment.id]: action.payload.transactions,
        },
        paginationParams: action.payload.paginationParams,
      };
    }

    case TransactionsActionType.SetPageSize: {
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    }

    case TransactionsActionType.SetCurrentPage: {
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    }

    case TransactionsActionType.SetFilters: {
      const newFilters = {
        ...state.filters,
        ...action.payload.filters,
      };

      if (isEqual(newFilters, state.filters)) {
        return state;
      } else {
        return {
          ...state,
          filters: newFilters,
        };
      }
    }

    case TransactionsActionType.SetSortParams: {
      return {
        ...state,
        sortParams: {
          ...action.payload.sortParams,
        },
      };
    }

    default:
      return state;
  }
};
